export default __webpack_public_path__ + "static/kaosite-a52a077478ec7584a3df55ed27002b93.png";